import '@availity/block-ui/src/BlockUi.css';

import React, { Component } from "react";
import BlockUi from '@availity/block-ui';

import { callBackendAPI, handleFormValidation,handleFormInputs, generateSource, cancelToken } from '../../helpers/common';
import {STATUS_SUCCESS , MASTER_DRIVER_TIER_LEVEL,MASTER_LOCATION,DEPARTMENT_DROPDOWN, MASTER_SKILL_SET, RADIO_YES, RADIO_NO}  from '../../config/global_constants';
import { translate  } from '../../helpers/intl_helpers';

class AddEditJobTitleForm extends Component {
	source;

	constructor(props) {
        super(props)

        this.state = {
			isLoading: 	true,
			errors: {},
			fields: {
				color_code : {value: "#ffffff"},
				show_on_schedule: { value: String(RADIO_NO) },
				order: { value: "" }
			},
			submitted: false,
        };

		this.closeModal 				=	this.closeModal.bind(this);
		this.handleFormInputs 			=	this.handleFormInputs.bind(this);
		this.handleJobTitleFormSubmit 	=  	this.handleJobTitleFormSubmit.bind(this);
		this.fetchDataForEdit 			=  	this.fetchDataForEdit.bind(this);
    }

	/** This function invoked immediately after a component is mounted.
	 * Its use to manage initial data fetch.
	 */
	componentDidMount() {
		this.fetchDataForEdit(this.props.masterId ? this.props.masterId :null);
    }

	componentWillUnmount(){
		cancelToken(this.source); // cancel the request
	}

	/**
	 * This function invoked immediately after updating occurs. This method is not called for the initial render.
	 * Its call when another update master form open
	 */
	componentDidUpdate(prevProps) {
        if (this.props.masterId !== prevProps.masterId) {
            this.fetchDataForEdit(this.props.masterId);
        }
    }

	/**
	* For get master details for edit modal
	*
	* @param id	as 	master id
	*
	* @return null
	*/
	fetchDataForEdit(id){
		window.document.body.classList.add("modal-open");
		window.document.body.classList.add("overflow-hidden");

		if(id){
			/** Generate source for cancel token */
			this.source = generateSource();

			/** Update loading stats */
			this.setState({ isLoading: true }, () => {
				callBackendAPI([{ model: 'master', method: 'masterDetails', master_id: id }],this.source).then((response) => {
						if (response.success && response.data[0].status === STATUS_SUCCESS) {
							let data = response.data[0].result || {};

							/** Update fields */
							this.setState({
								isLoading: false,
								fields: {
									master_id 			: { value: data?._id || "" },
									name	  			: { value: data?.name || "" },
									color_code			: { value: data?.color_code || "" },
									department			: { value: data?.department || "" },
									zip_code			: { value: data?.zip_code || "" },
									visible_on_calendar	: { value: String(data?.visible_on_calendar) || "" },
									show_on_schedule	: { value: String(data?.show_on_schedule) || "" },
									skill_order     	: { value: data?.skill_order || "" }
								}
							});
						}
					}).catch(err => console.log(err));

			});
		}else{
			this.setState({ isLoading : false});
		}
	}//fetchDataForEdit

	/**
	* For manage form submit event
	*
	* @param e  as current form object
	*
	* @return null
	*/
	handleJobTitleFormSubmit(e){
		e.preventDefault();

		const { name, master_id, color_code, department, visible_on_calendar,zip_code, show_on_schedule, skill_order} = this.state.fields;
		const dropdownType	= this.props.dropdownType
		let masterId  = (master_id && master_id.value) ? master_id.value : "";

		/** Api Requested Data **/
		let params = [{
			model		 		: 	'master',
			method		 		: 	'addEdit',
			master_id 			: 	masterId,
			name				: 	(name && name.value) ? name.value :"",
			color_code			: 	(color_code && color_code.value) ? color_code.value :"",
			department			: 	(department && department.value) ? department.value :"",
			visible_on_calendar	: 	(visible_on_calendar && visible_on_calendar.value) ? visible_on_calendar.value :"",
			dropdown_type		: 	dropdownType,
			zip_code			: 	(zip_code && zip_code.value) ? zip_code.value :"",
			show_on_schedule	: 	(show_on_schedule && show_on_schedule.value) 	?	show_on_schedule.value 	:"",
			skill_order				: 	(skill_order && skill_order.value) ? skill_order.value : "",
		}];

		/** Validation Rules **/
		let validations = {
			name : {"label": translate('master.master_name','Name'), "rules" :["required"]},
		}

		if(dropdownType && dropdownType === MASTER_DRIVER_TIER_LEVEL){
			validations["color_code"] = {"label": translate('master.master_color_code','Color Code'), "rules": ["select"]};
		}
		if(dropdownType && dropdownType === MASTER_SKILL_SET){
			validations["show_on_schedule"] = {"label": translate('master.show_on_schedule','Show On Schedule'), "rules": ["required"]};
			
			if (show_on_schedule && show_on_schedule.value === String(RADIO_YES)) {
				validations["skill_order"] = {"label": "Schedule Order","rules": ["required","integer"]}
			}
		}

		if(dropdownType && dropdownType === MASTER_LOCATION){
			validations["department"] = {"label": translate('master.master_department','Department'), "rules": ["select"]};
		}

		this.setState({submitted: true});

		/** Handle validation and api response **/
		handleFormValidation(validations,this.state.fields, params, true, true, true ).then(response =>{
			this.setState({submitted: false});
			if(!response.success) return this.setState({ errors : response.errors});

			/** Call the function to fetch list */
			if (this.props.refreshDataTable) {
				this.props.refreshDataTable();
			}
			/** Close the modal */
			this.closeModal(false);
			/** Remove disable attribute from submit button */
			this.setState({ errors: {} , fields: {} , submitted: false});

		}).catch(err => console.log(err));
	}

	/**
	* For hide model
	*
	* @return null
	*/
	closeModal(){
		window.document.body.classList.remove("modal-open");
		window.document.body.classList.remove("overflow-hidden");
		if(this.props.toggleModal) this.props.toggleModal(false);
		this.setState({ errors: {} , fields: {} });
	}// end closeModal()

	/**
	* For update state fileds values
	*
	* @param e  	as current field object
	* @param field  as current field name
	*
	* @return null
	*/
	handleFormInputs(e, field){
		let response =	handleFormInputs(e, field, this.state.fields);
		this.setState({ response });
	}// end handleFormInputs()

	render() {
		const {submitted, isLoading, fields, errors} = this.state;
		const isFormVisible 	=	this.props.isFormVisible;
		const masterId 			=	(fields && fields.master_id && fields.master_id.value) ? fields.master_id.value : ""
		const dropdownType		=	this.props.dropdownType;
		let modalHeadingTitle 	=	masterId ? translate("master.update."+dropdownType) : translate("master.add."+dropdownType);

		if(!masterId && dropdownType === "ctr_task") modalHeadingTitle = translate("master.add.new_task");

		return <>
			{/* Add Modal */}
			<div
				className={"modal fade "+(isFormVisible ? "show d-block" :"")}
				id="adduserModal"
				tabIndex={-1}
				aria-labelledby="adduserModal"
				aria-hidden="true"
			>
				<div className="modal-dialog">
					<div className="modal-content">
						<button
							type="button"
							className="btn-close"
							data-bs-dismiss="modal"
							aria-label="Close"
                            onClick={() => this.closeModal()}
						>
							X {translate("system.close")}
						</button>
						<div className="modal-body">
							<BlockUi tag="div" blocking={isLoading}>
								<h1 className="modal-title">{modalHeadingTitle}</h1>
								<div className="adduser-form">
									<form className="adduser-form" onSubmit={(event) => this.handleJobTitleFormSubmit(event, 'adduser-form')} noValidate>
										<div className="row">
											<div className="col-12 mb-3">
												<div className="form-group">
													<label htmlFor="name" className='mb-1 form-label'>{translate("master.master_name")}<span className="error text-danger">*</span></label>
													<input
														id="name"
														type="text"
														className="form-control input-with-label"
														placeholder={translate("master.master_name")}
														value={fields["name"] ? fields["name"]["value"] : ""}
														onChange={(event) => this.handleFormInputs(event, "name")}
													/>
													<span className="error text-danger">{errors["name"]}</span>
												</div>
											</div>
											{dropdownType && dropdownType === MASTER_DRIVER_TIER_LEVEL && (
												<>
													<div className="col-12 mb-3">
														<div className="form-group">
															<label htmlFor="color_code" className='mb-1 form-label'>{translate("master.master_color_code")}<span className="error text-danger">*</span></label>
															<input
																id="color_code"
																type="color"
																className="form-control input-with-label"
																placeholder={translate("master.master_color_code")}
																value={fields["color_code"] ? fields["color_code"]["value"] : ""}
																onChange={(event) => this.handleFormInputs(event, "color_code")}
															/>
															<span className="error text-danger">{errors["color_code"]}</span>
														</div>
													</div>
												</>
											)}
											{dropdownType && dropdownType === MASTER_SKILL_SET && (
												<div className="col-lg-6">
													<div className="form-check-group">
														<label htmlFor="show_on_schedule">{translate("employee.show_on_schedule")}<span className="error text-danger">*</span></label>
														<div className="form-group checkbox-row employee-checkbox-row">
															<div className="form-check form-check-inline custom-checkbox">
																<input className="form-check-input" type="radio" id="show_on_calendar" name="show_on_schedule" value={RADIO_YES} onChange={(e) => this.handleFormInputs(e, "show_on_schedule")} checked={fields.show_on_schedule && fields.show_on_schedule.value === String(RADIO_YES) ? true : false} />
																<label className="form-check-label" htmlFor="show_on_calendar">{translate("employee.yes")}</label>
															</div>
															<div className="form-check form-check-inline custom-checkbox">
																<input className="form-check-input" type="radio" id="not_show_on_calendar" name="show_on_schedule" value={RADIO_NO} onChange={(e) => this.handleFormInputs(e, "show_on_schedule")} checked={fields.show_on_schedule && fields.show_on_schedule.value === String(RADIO_NO) ? true : false} />
																<label className="form-check-label" htmlFor="not_show_on_calendar">{translate("employee.no")}</label>
															</div>
														</div>
														<span className="error text-danger">{errors["show_on_schedule"]}</span>
													</div>
												</div>

											)}
											{fields.show_on_schedule && fields.show_on_schedule.value === String(RADIO_YES) && (
												<div className="col-12 mb-3">
													<div className="form-group">
														<label
															htmlFor="skill_order"
															className="mb-1 form-label"
														>
															{translate("master.schedule_order")}
															<span className="error text-danger">*</span>
														</label>

														<input
															id="skill_order"
															type="text"
															className="form-control input-with-label"
															placeholder={translate("master.enter_schedule_order")}
															value={fields.skill_order ? fields.skill_order.value : ""}
															onChange={(event) =>
																this.handleFormInputs(event, "skill_order")
															}
														/>
														<span className="error text-danger">
															{errors["skill_order"]}
														</span>
													</div>
												</div>
											)}
											{dropdownType && dropdownType === MASTER_LOCATION && (
												<>
													<div className="col-12 mb-3">
														<div className="form-group">
															<label htmlFor="name" className='mb-1 form-label'>{translate("master.master_zip_code")}</label>
															<input
																id="zip_code"
																type="text"
																className="form-control input-with-label"
																placeholder={translate("master.master_zip_code")}
																value={fields["zip_code"] ? fields["zip_code"]["value"] : ""}
																onChange={(event) => this.handleFormInputs(event, "zip_code")}
															/>
														</div>
													</div>
													<div className="col-12 mb-3">
														<div className='form-group'>
															<label htmlFor="department" className='mb-1 form-label'>{translate("master.department")}<span className="error text-danger">*</span></label>
															<div className='checkbox-row employee-checkbox-row'>
																{DEPARTMENT_DROPDOWN.map((element, index) =>
																	<div className="form-check form-check-inline custom-checkbox mb-3" key={"department-" + index}>
																		<input
																			className="form-check-input"
																			type="checkbox"
																			name="department"
																			id={element.value}
																			value={element.value}
																			onChange={(event) => this.handleFormInputs(event, "department")}
																			checked={fields.department && fields.department.value ?
																				(fields.department.value.constructor === Array && fields.department.value.indexOf(element.value) !== -1 ?
																					true
																					:
																					fields.department.value.constructor === String && fields.department.value === element.value ?
																						true
																						: false
																				)
																				: false}
																		/>
																		<label className="form-check-label" htmlFor={element.value}>
																			{element.label}
																		</label>
																	</div>
																)}
															</div>
															<span className="error text-danger">{errors["department"]}</span>
														</div>
													</div>
												</>
											)}
										</div>
										<button type={submitted ? "button" :"submit"} className="btn btn-fill form-control width-initial mt-3">
											{translate("system.submit")} {submitted && <i className="spinner-border spinner-border-sm  ms-3"/>}
										</button>
									</form>
								</div>
							</BlockUi>
						</div>
					</div>
				</div>
			</div>
			{isFormVisible && <div className="modal-backdrop fade show"></div>}
		</>
	}
}
export default AddEditJobTitleForm;